import React, { useState } from 'react';
import { Modal } from "react-bootstrap";
import { Button, SvgIcon } from '@mui/material';
import PlayVideoIcon from '../../../../icons/play-video.svg?react';
import PropTypes from 'prop-types';

function VideoModal(props) {
  return (
    <Modal show={props.show} onHide={props.onHide} onClose={props.onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ratio ratio-16x9">
        <iframe src={props.link} title={props.title} />
      </Modal.Body>
    </Modal>
  )
}

export default function VideoButton(props) {

  const [videoModalIsOpen, setVideoModalIsOpen] = useState(false);

  return (
    <div className="video-button mb-3 px-0">
      <Button variant="text" color="primary" onClick={() => setVideoModalIsOpen(true)}>
        <SvgIcon component={PlayVideoIcon} className="icon" fontSize="large" />{props.title}
      </Button>
      <VideoModal title={props.title} link={props.link} show={videoModalIsOpen} onHide={() => setVideoModalIsOpen(false)} />
    </div>
  );
}

VideoButton.propTypes = {
  title: PropTypes.string.isRequired
};
